var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useState } from 'react';
import * as ExpoFileSystem from 'expo-file-system';
export function useFileSystem() {
    var _this = this;
    var _a = useState(null), file = _a[0], setFile = _a[1];
    var _b = useState(0), progress = _b[0], setProgress = _b[1];
    var _c = useState(false), downloading = _c[0], setDownloading = _c[1];
    var _d = useState(0), size = _d[0], setSize = _d[1];
    var _e = useState(null), error = _e[0], setError = _e[1];
    var _f = useState(false), success = _f[0], setSuccess = _f[1];
    var downloadFile = useCallback(function (fromUrl, toFile) {
        var callback = function (downloadProgress) {
            var currentProgress = Math.round((downloadProgress.totalBytesWritten /
                downloadProgress.totalBytesExpectedToWrite) *
                100);
            setProgress(currentProgress);
        };
        var downloadResumable = ExpoFileSystem.createDownloadResumable(fromUrl, ExpoFileSystem.documentDirectory + toFile, { cache: true }, callback);
        setDownloading(true);
        return downloadResumable
            .downloadAsync()
            .then(function (value) {
            if (!value)
                throw new Error('Download failed');
            if (value.headers['Content-Length']) {
                setSize(Number(value.headers['Content-Length']));
            }
            setSuccess(true);
            setError(null);
            setFile(value.uri);
            return { uri: value.uri, mimeType: value.mimeType };
        })
            .catch(function (err) {
            if (err instanceof Error) {
                setError(err.message);
            }
            else
                setError('Error downloading file');
            return { uri: null, mimeType: null };
        })
            .finally(function () { return setDownloading(false); });
    }, []);
    var getFileInfo = useCallback(function (fileUri) { return __awaiter(_this, void 0, void 0, function () {
        var _a, uri, exists, isDirectory, fileSize;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, ExpoFileSystem.getInfoAsync(fileUri)];
                case 1:
                    _a = (_b.sent()), uri = _a.uri, exists = _a.exists, isDirectory = _a.isDirectory, fileSize = _a.size;
                    return [2 /*return*/, {
                            uri: uri,
                            exists: exists,
                            isDirectory: isDirectory,
                            size: fileSize,
                        }];
            }
        });
    }); }, []);
    return {
        file: file,
        progress: progress,
        downloading: downloading,
        size: size,
        error: error,
        success: success,
        documentDirectory: ExpoFileSystem.documentDirectory,
        cacheDirectory: ExpoFileSystem.cacheDirectory,
        bundleDirectory: ExpoFileSystem.bundleDirectory,
        readAsStringAsync: ExpoFileSystem.readAsStringAsync,
        writeAsStringAsync: ExpoFileSystem.writeAsStringAsync,
        deleteAsync: ExpoFileSystem.deleteAsync,
        downloadFile: downloadFile,
        getFileInfo: getFileInfo,
    };
}
